(() => {
  const widgetSelector = '#judgeme_product_reviews .jm-sort-filter';

  function enhanceSort(filter) {
    if (filter.classList.contains('jm-sort-filter--quive')) return;
    const select = filter.querySelector('select');
    if (!select || !select.options.length) return;

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'quive-review-sort-trigger';
    trigger.setAttribute('aria-haspopup', 'menu');
    trigger.setAttribute('aria-expanded', 'false');

    const label = document.createElement('span');
    trigger.append(label);

    const menu = document.createElement('div');
    menu.className = 'quive-review-sort-menu';
    menu.setAttribute('role', 'menu');
    menu.setAttribute('aria-label', 'Sort reviews by');
    menu.hidden = true;

    const options = Array.from(select.options).filter((option) => option.value);
    options.forEach((option) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'quive-review-sort-option';
      item.setAttribute('role', 'menuitemradio');
      item.dataset.value = option.value;
      item.textContent = option.textContent.trim();
      item.tabIndex = -1;
      menu.append(item);
    });

    function update() {
      const chosen = select.selectedOptions[0];
      label.textContent = chosen?.textContent?.trim() || 'Most Recent';
      trigger.setAttribute('aria-label', `Sort reviews by: ${label.textContent}`);
      menu.querySelectorAll('.quive-review-sort-option').forEach((item) => {
        item.setAttribute('aria-checked', String(item.dataset.value === select.value));
      });
    }

    function close(returnFocus = false) {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    }

    function open(focusOption = false) {
      document.querySelectorAll('.quive-review-sort-trigger[aria-expanded="true"]').forEach((button) => {
        if (button !== trigger) button.click();
      });
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      if (focusOption) {
        (menu.querySelector('[aria-checked="true"]') || menu.querySelector('.quive-review-sort-option'))?.focus();
      }
    }

    trigger.addEventListener('click', () => menu.hidden ? open() : close());
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open(true);
      }
    });

    menu.addEventListener('click', (event) => {
      const item = event.target.closest('.quive-review-sort-option');
      if (!item) return;
      if (select.value !== item.dataset.value) {
        select.value = item.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      update();
      close(true);
    });

    menu.addEventListener('keydown', (event) => {
      const items = Array.from(menu.querySelectorAll('.quive-review-sort-option'));
      const index = items.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        items[(index + (event.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length]?.focus();
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        items[event.key === 'Home' ? 0 : items.length - 1]?.focus();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!filter.contains(event.target)) close();
    });
    select.addEventListener('change', update);

    update();
    filter.append(trigger, menu);
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    filter.classList.add('jm-sort-filter--quive');
  }

  let scheduled = false;
  function scan() {
    document.querySelectorAll(widgetSelector).forEach(enhanceSort);
  }

  scan();
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
